import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const createStreamPointer = createAsyncThunk(`stream/createPointer`, async (payload) => {
  try {
    const response = await magnifiAPI.createStreamPointer(payload);

    return response.data;
  } catch (error) {
    throw error?.response?.data;
  }
});

export const updateStreamPointer = createAsyncThunk(`stream/updatePointer`, async (payload) => {
  try {
    const response = await magnifiAPI.updateStreamPointer(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const getStreamPointers = createAsyncThunk(`stream/getPointers`, async (payload) => {
  try {
    const response = await magnifiAPI.getStreamPointer(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const deleteStreamPointer = createAsyncThunk(`stream/deletePointer`, async (payload) => {
  try {
    const response = await magnifiAPI.deleteStreamPointer(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const getAllStreamPointers = createAsyncThunk(`stream/getPointers`, async (payload) => {
  try {
    const response = await magnifiAPI.getAllStreamPointer(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});
